
import { Component, Vue, Prop } from 'vue-property-decorator'
import { AppModule } from '@/store/module'

@Component({
  components: {
  },
})
export default class Banner extends Vue {

  @Prop(String)
  imgH5: string

  @Prop(String)
  imgPc: string

  @Prop(String)
  alt: string

  @Prop({ type: String, default: '' })
  pcClassName: string
  
  @Prop({ type: String, default: '' })
  h5ClassName: string

  @Prop({ type: String, default: '' })
  title: string

  @Prop({ type: String, default: '' })
  subtitle: string

  @Prop({ type: String, default: '#542e0b' })
  copyColor: string

  @Prop({ type: String, default: 'right' })
  copyAlign: string

  @Prop({ type: String, default: '' })
  mobileCopyAlign: string

  @Prop({ type: String, default: 'right' })
  copySide: string

  @Prop({ type: Array, default: () => [] })
  bullets: string[]

  get isH5() {
    return AppModule.isH5
  }
}
